/*!

	bastardized and merged with jQuery dragscrollable Plugin
	no longer updatable

	Zoom v-x.7.8 - 2014-08-14
	Enlarge images on click or mouseover.
	(c) 2013 Jack Moore - http://www.jacklmoore.com/zoom
	license: http://www.opensource.org/licenses/mit-license.php
*/
(function ($) {
	var defaults = {
		url: false,
		callback: false,
		target: false,
		duration: 120,
		on: 'mouseover', // other options: 'grab', 'click', 'toggle', 'toggle-grab'
		movementCushion: 10, // only for toggle-grab method
		beforeZoomIn: false,
		onZoomIn: false,
		onZoomOut: false
	};

	// Core Zoom Logic, independent of event listeners.
	$.zoom = function(target, source, img) {
		var outerWidth,
			outerHeight,
			xRatio,
			yRatio,
			offset,
			position = $(target).css('position');

		// The parent element needs positioning so that the zoomed element can be correctly positioned within.
		$(target).css({
			position: /(absolute|fixed)/.test(position) ? position : 'relative',
			overflow: 'hidden'
		});

		img.style.width = img.style.height = '';

		$(img)
			.addClass('zoomImg')
			.css({
				position: 'absolute',
				top: 0,
				left: 0,
				opacity: 0,
				width: img.width,
				height: img.height,
				border: 'none',
				maxWidth: 'none'
			})
			.appendTo(target);

		return {
			init: function() {
				outerWidth = $(target).outerWidth();
				outerHeight = $(target).outerHeight();
				xRatio = (img.width - outerWidth) / $(source).outerWidth();
				yRatio = (img.height - outerHeight) / $(source).outerHeight();
				offset = $(source).offset();
			},
			move: function (evt) {
				var left = (evt.pageX - offset.left),
					top = (evt.pageY - offset.top);

				top = Math.max(Math.min(top, outerHeight), 0);
				left = Math.max(Math.min(left, outerWidth), 0);

				$(target)
					.scrollLeft(left * xRatio)
					.scrollTop(top * yRatio);
			}
		};
	};

	$.fn.zoom = function (options) {
		return this.each(function () {
			var settings = $.extend({}, defaults, options || {}),
				//target will display the zoomed image
				target = settings.target || this,
				//source will provide zoom location info (thumbnail)
				source = this,
				img = document.createElement('img'),
				$img = $(img),
				clicked = false,
				$urlElement;

			// If a url wasn't specified, look for an image element.
			if (!settings.url) {
				$urlElement = $(source).find('img');
				if ($urlElement[0]) {
					settings.url = $urlElement.data('src') || $urlElement.attr('src');
				}
				if (!settings.url) {
					return;
				}
			}

			img.onload = function () {
				var zoom = $.zoom(target, source, img);

				function start(evt) {
					$.isFunction(settings.beforeZoomIn) ? settings.beforeZoomIn.call(img) : false;

					zoom.init();
					zoom.move(evt);

					// Skip the fade-in for IE8 and lower since it chokes on fading-in
					// and changing position based on mousemovement at the same time.
					$img.stop()
					.fadeTo($.support.opacity ? settings.duration : 0, 1, $.isFunction(settings.onZoomIn) ? settings.onZoomIn.call(img) : false);

					$(target).one('stopeverything.zoom', function(evt) {
						stop( );
						initToggleGrab( );
					});
				}

				function stop() {
					$img.stop()
					.fadeTo(settings.duration, 0, $.isFunction(settings.onZoomOut) ? settings.onZoomOut.call(img) : false);

					// reset the scroll back to where it started
					$(target).scrollLeft(0).scrollTop(0);
				}

				function dragDown(evt) {
					if ((1 !== evt.which) && (0 !== evt.which)) { // left mouse button and touch only
						return false;
					}

					evt.preventDefault( );

					if ('undefined' === typeof evt.data) {
						evt.data = { };
					}

					// initial coordinates will be the last when dragging
					evt.data.lastCoord = {
						left: evt.clientX,
						top: evt.clientY
					};

					evt.data.startCoord = {
						left: evt.clientX,
						top: evt.clientY
					};

					$(target).one('mouseup.zoom', evt.data, dragUp);
					$(target).on('mousemove.zoom', evt.data, dragMove);
				};

				function dragMove(evt) { // User is dragging
					evt.preventDefault( );

					// How much did the mouse move?
					var delta = {
						left: (evt.clientX - evt.data.lastCoord.left),
						top: (evt.clientY - evt.data.lastCoord.top)
					};

					// Set the scroll position relative to what ever the scroll is now
					$(target).scrollLeft($(target).scrollLeft( ) - delta.left);
					$(target).scrollTop($(target).scrollTop( ) - delta.top);

					// Save where the cursor is
					evt.data.lastCoord = {
						left: evt.clientX,
						top: evt.clientY
					};
				};

				function dragUp(evt) { // Stop scrolling
					evt.preventDefault( );
					evt.stopPropagation( );

					// did the mouse move?
					var delta = {
						left: Math.abs(evt.clientX - evt.data.startCoord.left),
						top: Math.abs(evt.clientY - evt.data.startCoord.top)
					};

					$(target).off('mousemove.zoom', dragMove);

					// only stop propogation if there was minimal mouse movement
					if ((settings.movementCushion >= delta.left) && (settings.movementCushion >= delta.top)) {
						$(target).off('mousedown.zoom', dragDown)
						stop( );

						// another event: click will get fired right after the current event finishes
						// so prevent the initToggleGrab from firing because of this click
						$(source).one('click.zoom', function (evt) {
							evt.stopImmediatePropagation( );
							return false;
						});

						initToggleGrab( );
					}

					return false;
				};

				function initToggleGrab( ) {
					$(source).one('click.zoom', function (evt) {
						start(evt);
						$(target).on('mousedown.zoom', dragDown);
					});
				}

				if (settings.on === 'grab') {
					$(source).on('mousedown.zoom',
						function (evt) {
							if (evt.which === 1) {
								$(document).one('mouseup.zoom',
									function () {
										stop();

										$(document).off('mousemove.zoom', zoom.move);
									}
								);

								start(evt);

								$(document).on('mousemove.zoom', zoom.move);

								evt.preventDefault();
							}
						}
					);
				} else if (settings.on === 'toggle-grab') {
					initToggleGrab( );
				} else if (settings.on === 'click') {
					$(source).on('click.zoom',
						function (evt) {
							if (clicked) {
								// bubble the event up to the document to trigger the unbind.
								return;
							} else {
								clicked = true;
								start(evt);
								$(document).on('mousemove.zoom', zoom.move);
								$(document).one('click.zoom',
									function () {
										stop();
										clicked = false;
										$(document).off('mousemove.zoom', zoom.move);
									}
								);
								return false;
							}
						}
					);
				} else if (settings.on === 'toggle') {
					$(source).on('mouseup.zoom',
						function (evt) {
							if (clicked) {
								stop();
							} else {
								start(evt);
							}
							clicked = !clicked;
						}
					);
				} else {
					zoom.init(); // Preemptively call init because IE7 will fire the mousemove handler before the hover handler.

					$(source)
						.on('mouseenter.zoom', start)
						.on('mouseleave.zoom', stop)
						.on('mousemove.zoom', zoom.move);
				}

				if ($.isFunction(settings.callback)) {
					settings.callback.call(img);
				}
			};

			img.src = settings.url;

			$(source).one('zoom.destroy', function(){
				$(source).off(".zoom");
				$img.remove();
			});
		});
	};

	$.fn.zoom.defaults = defaults;
}(window.jQuery));
